import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { isPerplexityUrl } from '#pplx/frontend/apps/ask/suggest-dropdown/primitives/utils/utils.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { defineMessages, useIntl } from 'react-intl';
const messages = defineMessages({
    fill: {
        id: '44d8b89cd7',
        defaultMessage: 'Fill query',
        description: 'Fill the input with an autosuggestion without submitting it',
    },
    open: {
        id: '44805bb5d9',
        defaultMessage: 'Open in new tab',
        description: 'Open a suggested website in a new browser tab',
    },
});
export function SuggestionRightAccessory({ onClick, url, category, }) {
    const { $t } = useIntl();
    if (category === 'shortcuts')
        return null;
    if (isPerplexityUrl(url)) {
        return (_jsx("div", { className: "flex h-full items-center", children: _jsx(Icon, { icon: $icon('chevron-right'), size: "small", color: "light" }) }));
    }
    const arrowIcon = import.meta.env.VITE_IS_SIDECAR_BUILD
        ? $icon('arrow-down-left')
        : $icon('arrow-up-right');
    return (_jsx(ButtonPrimitive, { "aria-label": $t(url ? messages.open : messages.fill), className: "appearance-none inline-flex items-center justify-center", onPointerDown: (event) => {
            // Fill without selecting the surrounding row or moving focus out of the editor.
            event.stopPropagation();
            event.preventDefault();
            onClick(event);
        }, onMouseDown: (event) => event.stopPropagation(), onClick: (event) => event.stopPropagation(), children: _jsx(Icon, { icon: url ? $icon('world-share') : arrowIcon, size: "small" }) }));
}
//# sourceMappingURL=SuggestionRightAccessory.js.map